import React from "react";
import { ArrowLeft } from "lucide-react";
import { useHistory } from "react-router-dom";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";

const TicketHeader = ({ loading, children }) => {
  const history = useHistory();

  if (loading) return <TicketHeaderSkeleton />;

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex-none">
      <button
        onClick={() => history.push("/tickets")}
        className="p-1.5 rounded-lg text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex-shrink-0"
      >
        <ArrowLeft className="w-4 h-4" />
      </button>
      {children}
    </div>
  );
};

export default TicketHeader;
